// Dynamic filtering for hide_variant_from_pdp metafield.
// Hides option values whose only compatible combinations with the current variant are
// all marked hidden via the custom.hide_variant_from_pdp variant metafield.
(function () {
  function init() {
    if (typeof window.__variantMeta === 'undefined') return;

    var allVariants = Object.keys(window.__variantMeta).map(function (id) {
      var m = window.__variantMeta[id];
      return {
        option1: m.option1,
        option2: m.option2,
        option3: m.option3,
        hideFromPdp: m.hide_from_pdp
      };
    });

    if (!allVariants.some(function (v) { return v.hideFromPdp; })) return;

    // Returns true when every variant that (a) has optionText at optionPosition and
    // (b) shares the same values at all OTHER positions as currentVariant has hideFromPdp set.
    function shouldHide(optionPosition, optionText, currentVariant) {
      var key = 'option' + optionPosition;
      var matching = allVariants.filter(function (v) { return v[key] === optionText; });
      if (matching.length === 0) return false;

      var compatible = matching.filter(function (v) {
        for (var i = 1; i <= 3; i++) {
          if (i === optionPosition) continue;
          var cur = currentVariant['option' + i];
          var cand = v['option' + i];
          // If both have a value and they differ, this combination is not relevant
          if (cur && cand && cand !== cur) return false;
        }
        return true;
      });

      if (compatible.length === 0) return false;
      return compatible.every(function (v) { return v.hideFromPdp; });
    }

    // Read the display text for an option value radio from its associated label.
    function getOptionText(input, picker) {
      // Dropdown style: input lives inside <label class="popover__value-option">
      var parentLabel = input.closest('label.popover__value-option');
      if (parentLabel) {
        var spans = parentLabel.querySelectorAll('span');
        for (var i = 0; i < spans.length; i++) {
          if (!spans[i].classList.contains('sr-only')) {
            return spans[i].textContent.trim();
          }
        }
        return null;
      }

      // Swatch / block style: sibling <label for="inputId">
      if (input.id) {
        var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(input.id) : input.id;
        var label = picker.querySelector('label[for="' + esc + '"]');
        if (label) {
          var srOnly = label.querySelector('.sr-only');
          return srOnly ? srOnly.textContent.trim() : null;
        }
      }

      return null;
    }

    // Get the element to toggle hidden on for a given input.
    function getHideTarget(input, picker) {
      var parentLabel = input.closest('label.popover__value-option');
      if (parentLabel) return parentLabel;

      var parentDiv = input.closest('div.popover__value-option');
      if (parentDiv) return parentDiv;

      if (input.id) {
        var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(input.id) : input.id;
        return picker.querySelector('label[for="' + esc + '"]');
      }

      return null;
    }

    function updateVisibility(picker, currentVariant) {
      if (!currentVariant) return;

      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position'), 10);
        if (!pos) return;

        var text = getOptionText(input, picker);
        if (!text) return;

        var target = getHideTarget(input, picker);
        if (!target) return;

        // Never hide the currently active value for this option position
        if (currentVariant['option' + pos] === text) {
          target.removeAttribute('hidden');
          input.disabled = false;
          return;
        }

        if (shouldHide(pos, text, currentVariant)) {
          target.setAttribute('hidden', '');
          input.disabled = true;
        } else {
          target.removeAttribute('hidden');
          input.disabled = false;
        }
      });
    }

    // Read the currently selected variant from the server-rendered JSON script tag.
    function getInitialVariant(picker) {
      var script = picker.querySelector('script[data-variant]');
      if (!script) return null;
      try { return JSON.parse(script.textContent); } catch (e) { return null; }
    }

    // Initial run on page load
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      updateVisibility(picker, getInitialVariant(picker));
    });

    // Re-run on every variant change (event fires AFTER product:rerender updates the DOM).
    // event.detail.variant has option1/option2/option3 text values from the theme.
    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      document.querySelectorAll('variant-picker').forEach(function (picker) {
        updateVisibility(picker, variant);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
